import { createSlice } from '@reduxjs/toolkit';
import { FULLFILLED } from '@root/constants';
import { ADMIN_LOGIN_ACTION, GET_ADMIN_PROFILE_ACTION } from '@root/store/action-types/admin/auth';


const INITIAL_STATE = {
    isAdmin: false,
    user: {}
};

export const userSlice = createSlice({
    name: 'user',
    initialState: INITIAL_STATE,
    reducers: {
        updateAdminStatus: (state, { payload }) => {
            state.isAdmin = payload
        },
        updateAdminProfile: (state, { payload }) => {
            state.user = payload
        }
    },
    extraReducers: (builder) => {
        builder.addCase(`${ADMIN_LOGIN_ACTION}${FULLFILLED}`, (state, action: any) => {
            state.isAdmin = true;
            state.user = action.payload
        });
        builder.addCase(`${GET_ADMIN_PROFILE_ACTION}${FULLFILLED}`, (state, action: any) => {
            state.isAdmin = true;
            state.user ={user: action.payload}
        });
    }
});

export const {
    updateAdminStatus,
    updateAdminProfile
} = userSlice.actions;

export const adminUserReducer = userSlice.reducer;
